import React from "react";
import { Alert, IconButton, Snackbar } from "@mui/material";
import { AppState, useAppSelector } from "../../../store";
import { ISnackbarType } from "../../../types/SnackbarTypes";
import { useSnackbar } from "../../../hooks/useSnackbar";
import { Close } from "@mui/icons-material";

const SnackbarComponent: React.FC = () => {
  const snackbar: ISnackbarType = useAppSelector(
    (state: AppState) => state.snackbarSlice.snackbar
  );
  const { autoHideSnackbar, hideSnackbar } = useSnackbar();
  return (
    <Snackbar
      open={snackbar.open}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      autoHideDuration={snackbar.stayOpen ? null : 3000}
      onClose={autoHideSnackbar}
    >
      <Alert severity={snackbar.severity} id={snackbar?.id ? `${snackbar?.id}-message` : `${snackbar.severity}-message`}
      action={
        snackbar.stayOpen ? (
          <IconButton aria-label="close" color="inherit" sx={{ p: 0.5 }} onClick={hideSnackbar}>
            <Close fontSize="small" />
          </IconButton>
        ) : null
      }
      >{snackbar.message}
        
      </Alert>
    </Snackbar>
  );
};

export default SnackbarComponent;
